import * as yup from 'yup';
import { isValidPhoneNumber } from 'react-phone-number-input';

export const isPhoneNumberValid = (value: string | undefined) => {
  if (value) {
    return isValidPhoneNumber(value);
  }
  return true;
};
const FILE_SIZE = 10 * 1024 * 1024; // 10 MB
const SUPPORTED_FORMATS = ['image/jpeg', 'image/png', 'image/bmp'];
export const validation = {
  chatTitle: yup
    .string()
    .trim()
    .max(50, 'Title should not contain more than 50 characters')
    .required('Title is required!'),
  firstName: yup
    .string()
    .trim()
    .max(30, 'First Name should not contain more than 30 characters')
    .matches(/^[a-zA-Z\u00C0-\u017F ]*$/, 'First Name cannot contain special character and numbers.')
    .required('First Name is required!'),
  familyName: yup
    .string()
    .trim()
    .max(30, 'Last Name should not contain more than 30 characters')
    .matches(/^[a-zA-Z\u00C0-\u017F ]*$/, 'Last Name cannot contain special character and numbers.')
    .required('Last Name is required!'),
  email: yup
    .string()
    .trim()
    .max(200, 'Email Address should not contain more than 200 characters')
    .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, {
      message: 'Invalid Email Address!',
    })
    .test(
      'gmail-validation',
      'Invalid Email Address!',
      (value) => !!value && ((value.includes('@gmail') && value.endsWith('.com')) || !value.includes('@gmail')),
    )
    .required('Email Address is required!'),
  password: yup
    .string()
    .trim()
    .required('Password is required!')
    .min(8, 'Password should be at least 8 characters long')
    .max(30, 'Password should not contain more than 30 characters')
    .matches(/\d/, 'Password requires a number')
    .matches(/[a-z]/, 'Password requires a lowercase letter')
    .matches(/[A-Z]/, 'Password requires an uppercase letter')
    .matches(/[^\w]/, 'Password requires a special character'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password')], 'Password doesn’t match!')
    .required('Confirm Password is required!'),
  passwordForLogin: yup.string().trim().required('Password is required!'),
  emailOrUsername: yup
    .string()
    .trim()
    .required('Email Address/Username is required!')
    .test('email-or-username', 'Please enter a valid email address/username', (value) => {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const usernameRegex = /^[a-zA-Z0-9_.-]+$/; // Adjust regex for username validation
      if (
        emailRegex.test(value) &&
        ((value.includes('@gmail') && value.endsWith('.com')) || !value.includes('@gmail'))
      ) {
        return value.length <= 200;
      }
      if (usernameRegex.test(value)) {
        return value.length <= 30 && value.length >= 5;
      }
      return false;
    }),
  phoneNumber: yup
    .string()
    .optional()
    .test('phoneNumber', 'Invalid Mobile Number!', isPhoneNumberValid)
    .required('Mobile Number is required!'),
  message: yup
    .string()
    .trim()
    .required('Your Message is required!')
    .max(2000, 'Your Message should not contain more than 2000 characters'),
  username: yup
    .string()
    .required('Username is required!')
    .strict()
    .min(5, 'Username must be at least 5 characters long')
    .max(30, 'Username cannot exceed 30 characters')
    .matches(/^\w+$/, 'Username can only contain letters, numbers, and underscores (no spaces or special characters)')
    .test('no-spaces', 'Username cannot contain spaces', (value) => typeof value === 'string' && !/\s/.test(value)),
  companyName: yup
    .string()
    .trim()
    .max(30, 'Company Name should not contain more than 30 characters')
    .matches(/^[a-zA-Z0-9 ]*$/, 'Company Name cannot contain special characters.')
    .required('Company Name is required!'),
  country: yup.string().required('Country is required!'),
  role: yup.string().required('Role is required!'),
  designationId: yup.string().required('Your Role in the Company is required!'),
  customDesignation: yup.string().required('Your Role in the Company is required!'),
  companyWebsite: yup.string().trim().max(30, 'Company Website should not contain more than 30 characters'),
  isAgreedToTermsAndCondition: yup
    .boolean()
    .oneOf([true], 'You have to read and agree with terms and conditions of use to continue!'),
  uploadGemFieldValidation: yup.string().trim().required('This is a mandatory field!'),
  weight: yup
    .number()
    .min(0.5, 'Weight should greater than 0.5')
    .max(20, 'Weight should be less than 20')
    .required('This is a mandatory field!'),
  dimensions: yup
    .number()
    .min(3, 'Dimensions should greater than 3')
    .max(25, 'Dimensions should be less than 25')
    .required('This is a mandatory field!'),
  cut: yup.string().trim().required('Cut is required!'),
  shape: yup.string().trim().required('shape is required!'),
  certificate: yup.string().trim().required('certificate is required!'),
  file: yup
    .mixed()
    .required('This is a mandatory field!')
    .test(
      'fileSize',
      "The image you're trying to upload exceeds the maximum allowed size of 10MB. " +
        'Please upload an image that is less than 10MB.',
      (value: any) => !value || (value && value.size <= FILE_SIZE),
    )
    .test(
      'fileFormat',
      'Unsupported file format',
      (value: any) => !value || (value && SUPPORTED_FORMATS.includes(value.type)),
    ),
  subordinateOrganizationSignUp: yup.string().trim().required('Company Name is required!'),
  pin: yup
    .string()
    .required('PIN is required!')
    .matches(/^\d{4}$/, 'PIN must be 4 digits'),

  confirmPin: yup
    .string()
    .oneOf([yup.ref('pin')], 'PIN does not match!')
    .required('Confirm PIN is required!'),
};
